import { Injectable } from '@angular/core';

import { AbstractToolService } from './abstract-tool.service';
import { DataModelService } from '../services/data-model.service';
import { LayoutControlContainer } from '../types';
import { DesignHostComponent } from '../components/design-host/design-host.component';

@Injectable({
  providedIn: 'root'
})
export class CutToolService extends AbstractToolService {
  private _source: DesignHostComponent;

  constructor(protected dataModelService: DataModelService) {
    super();
  }

  start(source: DesignHostComponent) {
    this._source = source;
  }

  do(host: LayoutControlContainer, args: any) {
    if (host.control.isContainer) {
      const dataModel = this._source.control.getDataModel();
      const layoutModel = this.dataModelService.translateDataModel2LayoutModel(dataModel);
      this._source.remove();
      if (host.control.addControl) {
        host.control.addControl(layoutModel);
      }
      super.raiseCompletedEvent(args);
    }
  }
}
